module.exports = __webpack_public_path__ + "img/UCG.dc250147.png";